export default __webpack_public_path__ + "d4d3988d0ba0b6c01f5a5b9393019dc7.svg";